import { cn } from "cn"
import { SpinnerIcon } from "@phosphor-icons/react/ssr"

function Spinner({ className, ...props }: React.ComponentProps<"svg"> & { "aria-label": string }) {
  return <SpinnerIcon data-slot="spinner" role="status" className={cn("size-4 animate-spin", className)} {...props} />
}

export { Spinner }
